import _defineProperty from "/home/websuasion/thelongtermcareplanninggroup.com/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/websuasion/thelongtermcareplanninggroup.com/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/websuasion/thelongtermcareplanninggroup.com/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { whichButtons, getOffsetPosition } from './event-utils';
var DEFAULT_OPTIONS = {
  srcElement: 'root',
  priority: 0
};
var EventRegistrar = /*#__PURE__*/function () {
  function EventRegistrar(eventManager) {
    var _this = this;
    _classCallCheck(this, EventRegistrar);
    /**
     * Handles hammerjs event
     */
    this.handleEvent = function (event) {
      if (_this.isEmpty()) {
        return;
      }
      var mjolnirEvent = _this._normalizeEvent(event);
      var target = event.srcEvent.target;
      while (target && target !== mjolnirEvent.rootElement) {
        _this._emit(mjolnirEvent, target);
        if (mjolnirEvent.handled) {
          return;
        }
        target = target.parentNode;
      }
      _this._emit(mjolnirEvent, 'root');
    };
    this.eventManager = eventManager;
    this.handlers = [];
    // Element -> handler map
    this.handlersByElement = new Map();
    this._active = false;
  }
  // Returns true if there are no non-passive handlers
  _createClass(EventRegistrar, [{
    key: "isEmpty",
    value: function isEmpty() {
      return !this._active;
    }
  }, {
    key: "add",
    value: function add(type, handler, options) {
      var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var passive = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var handlers = this.handlers,
        handlersByElement = this.handlersByElement;
      var opts = DEFAULT_OPTIONS;
      if (typeof options === 'string' || options && options.addEventListener) {
        // is DOM element, backward compatibility
        // @ts-ignore
        opts = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), {}, {
          srcElement: options
        });
      } else if (options) {
        opts = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
      }
      var entries = handlersByElement.get(opts.srcElement);
      if (!entries) {
        entries = [];
        handlersByElement.set(opts.srcElement, entries);
      }
      var entry = {
        type: type,
        handler: handler,
        srcElement: opts.srcElement,
        priority: opts.priority
      };
      if (once) {
        entry.once = true;
      }
      if (passive) {
        entry.passive = true;
      }
      handlers.push(entry);
      this._active = this._active || !entry.passive;
      // Sort handlers by descending priority
      // Handlers with the same priority are excuted in the order of registration
      var insertPosition = entries.length - 1;
      while (insertPosition >= 0) {
        if (entries[insertPosition].priority >= entry.priority) {
          break;
        }
        insertPosition--;
      }
      entries.splice(insertPosition + 1, 0, entry);
    }
  }, {
    key: "remove",
    value: function remove(type, handler) {
      var handlers = this.handlers,
        handlersByElement = this.handlersByElement;
      for (var i = handlers.length - 1; i >= 0; i--) {
        var entry = handlers[i];
        if (entry.type === type && entry.handler === handler) {
          handlers.splice(i, 1);
          var entries = handlersByElement.get(entry.srcElement);
          entries.splice(entries.indexOf(entry), 1);
          if (entries.length === 0) {
            handlersByElement.delete(entry.srcElement);
          }
        }
      }
      this._active = handlers.some(function (entry) {
        return !entry.passive;
      });
    }
    /**
     * Invoke handlers on a particular element
     */
  }, {
    key: "_emit",
    value: function _emit(event, srcElement) {
      var entries = this.handlersByElement.get(srcElement);
      if (entries) {
        var immediatePropagationStopped = false;
        // Prevents the current event from bubbling up
        var stopPropagation = function stopPropagation() {
          event.handled = true;
        };
        // Prevent any remaining listeners from being called
        var stopImmediatePropagation = function stopImmediatePropagation() {
          event.handled = true;
          immediatePropagationStopped = true;
        };
        var entriesToRemove = [];
        for (var i = 0; i < entries.length; i++) {
          var _entries$i = entries[i],
            type = _entries$i.type,
            handler = _entries$i.handler,
            once = _entries$i.once;
          handler(_objectSpread(_objectSpread({}, event), {}, {
            // @ts-ignore
            type: type,
            stopPropagation: stopPropagation,
            stopImmediatePropagation: stopImmediatePropagation
          }));
          if (once) {
            entriesToRemove.push(entries[i]);
          }
          if (immediatePropagationStopped) {
            break;
          }
        }
        for (var _i = 0; _i < entriesToRemove.length; _i++) {
          var _entriesToRemove$_i = entriesToRemove[_i],
            _type = _entriesToRemove$_i.type,
            _handler = _entriesToRemove$_i.handler;
          this.remove(_type, _handler);
        }
      }
    }
    /**
     * Normalizes hammerjs and custom events to have predictable fields.
     */
  }, {
    key: "_normalizeEvent",
    value: function _normalizeEvent(event) {
      var rootElement = this.eventManager.getElement();
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, event), whichButtons(event)), getOffsetPosition(event, rootElement)), {}, {
        preventDefault: function preventDefault() {
          event.srcEvent.preventDefault();
        },
        stopImmediatePropagation: null,
        stopPropagation: null,
        handled: false,
        rootElement: rootElement
      });
    }
  }]);
  return EventRegistrar;
}();
export { EventRegistrar as default };